import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Player } from "@/types/Player";

interface PlayerState {
    players: Player[];
    loading: boolean;
    error: string | null;
}

const initialState: PlayerState = {
    players: [],
    loading: false,
    error: null,
};

const playerSlice = createSlice({
    name: "player",
    initialState,
    reducers: {
        // Add a new player to the state array
        addPlayer(state, action: PayloadAction<Player>) {
            state.players.push(action.payload);
        },

        // Remove an existing player by id
        removePlayer(state, action: PayloadAction<number>) {
            state.players = state.players.filter(
                (player) => player.id !== action.payload
            );
        },

        // Update an existing player by matching on id
        updatePlayer(state, action: PayloadAction<Player>) {
            const updated = action.payload;
            const index = state.players.findIndex((p) => p.id === updated.id);
            if (index !== -1) {
                state.players[index] = updated;
            }
        },

        setPlayers(state, action: PayloadAction<Player[]>) {
            state.players = action.payload;
        },

        // Toggle the pinned state of a player by id
        setPlayerPinned(
            state,
            action: PayloadAction<{ id: number; isPinned: boolean }>
        ) {
            const { id, isPinned } = action.payload;
            const player = state.players.find((p) => p.id === id);
            if (player) {
                player.isPinned = isPinned;
            }
        },
    },
});

export const {
    addPlayer,
    removePlayer,
    updatePlayer ,
    setPlayers,
    setPlayerPinned,
} = playerSlice.actions;
export default playerSlice.reducer;